import Vue from 'vue'
import VueRouter from 'vue-router'
//首页
import Home from '../pages/home/index.vue'/* 首页 */
import Mine from '../pages/mine/index.vue'/* 我的 */
import Choose from '../pages/choose/index.vue'/* 选妃 */
import List from '../pages/choose/list.vue'/* 选妃列表 */
import Profile from '../pages/choose/profile.vue'/* 选妃详情 */
import Video from '../pages/video/index.vue'/* 视频 */
import Game from '../pages/game/index.vue'/* 游戏 */
import Login from '../pages/login/index.vue'/* 登录 */
import Register from '../pages/login/register.vue'/* 注册 */
import ServiceOnline from '../pages/mine/ServiceOnline.vue'/* 客服列表 */
import ServicePage from '../pages/mine/ServicePage.vue'/* 客服详情界面 */
import Setting from '../pages/mine/Setting.vue'/* 设置 */
import Infomation from '../pages/mine/Infomation.vue'/* 基本信息 */
import Setname from '../pages/mine/Setname.vue'/* 修改姓名 */
import Language from '../pages/mine/Language.vue'/* 语言选择 */
import Setsex from '../pages/mine/Setsex.vue'/* 修改姓名 */
import Recharge from '../pages/mine/Recharge.vue'/* 充值 */
import SetPayPassword from '../pages/mine/SetPayPassword.vue'/* 修改提现密码 */
import SetLoginPassword from '../pages/mine/SetLoginPassword.vue'/* 修改提现密码 */
import Lottery from '../pages/lottery/index.vue'/* 彩票详情 */
import Notice from '../pages/mine/Notice.vue'/* 公告 */
import PlayVideo  from '../pages/video/PlayVideo'/* 视频播放页面 */
import Setbank  from '../pages/mine/Setbank'/* 视频播放页面 */
import TrcCard  from '../pages/mine/TrcCard.vue'/* 绑定银行卡界面 */
import BindCard  from '../pages/mine/BindCard'/* 绑定虚拟货币界面 */
import Withdraw  from '../pages/mine/Withdraw'/* 绑定银行卡界面 */
import Personalreport  from '../pages/mine/Personalreport'/* 个人表报 */
import GameRecord  from '../pages/mine/GameRecord'/* 游戏记录 */
import WithdrawRecord  from '../pages/mine/WithdrawRecord'/* 提现记录 */
import Account  from '../pages/mine/Account'/* 账户详情 */
import History from '../pages/history/index.vue' //黑料
import Trc20 from '../pages/mine/Trc20.vue'//虚拟货币提现
import Settrc from '../pages/mine/Settrc.vue'//设置虚拟货币地址
import Torules from '../pages/mine/Torules.vue'//平台规则


Vue.use(VueRouter)
const routes = [
    {path:'/',redirect:'/Home',component:Home,meta:{title:'halaman Depan'}},
    {path:'/Home',name:'home',component:Home,meta:{title:'halaman Depan'}},
	{path:'/Choose',name:'choose',component:Choose,meta:{title:'Pilih selir'}},
	{path:'/List',name:'list',component:List,meta:{title:'Daftar selir terpilih'}},
	{path:'/Profile',name:'profile',component:Profile,meta:{title:'Detail pemilihan selir'}},
    {path:'/Mine',name:'mine',component:Mine,meta:{title:'milikku'}},
    {path:'/Video',name:'video',component:Video,meta:{title:'video'}},
    {path:'/Game',name:'game',component:Game,meta:{title:'permainan'}},
    {path:'/Login',name:'login',component:Login,meta:{title:'Gabung'}},
    {path:'/Register',name:'register',component:Register,meta:{title:'daftar'}},
    {path:'/ServiceOnline',name:'ServiceOnline',component:ServiceOnline,meta:{title:'layanan daring'}},
    {path:'/ServicePage',name:'ServicePage',component:ServicePage,meta:{title:'layanan daring'}},
    {path:'/Setting',name:'Setting',component:Setting,meta:{title:'mempersiapkan'}},
    {path:'/Infomation',name:'Infomation',component:Infomation,meta:{title:'Informasi dasar'}},
    {path:'/Setname',name:'Setname',component:Setname,meta:{title:'Ubah nama'}},
    {path:'/Setsex',name:'Setsex',component:Setsex,meta:{title:'perubahan gender'}},
    {path:'/Language',name:'Language',component:Language,meta:{title:'pilihan bahasa'}},
    {path:'/Recharge',name:'Recharge',component:Recharge,meta:{title:'isi ulang'}},
    {path:'/SetPayPassword',name:'SetPayPassword',component:SetPayPassword,meta:{title:'Ubah kata sandi penarikan'}},
    {path:'/SetLoginPassword',name:'SetLoginPassword',component:SetLoginPassword,meta:{title:'Kelola kata sandi masuk'}},
    {path:'/Lottery',name:'Lottery',component:Lottery,meta:{title:'Detail lotere'}},
    {path:'/Notice',name:'Notice',component:Notice,meta:{title:'pengumuman'}},
    {path:'/PlayVideo',name:'PlayVideo',component:PlayVideo,meta:{title:'Halaman pemutaran video'}},
    {path:'/Setbank',name:'Setbank',component:Setbank,meta:{title:'Ikat kartu bank'}},
    {path:'/BindCard',name:'BindCard',component:BindCard,meta:{title:'Ikat kartu bank'}},
    {path:'/Withdraw',name:'Withdraw',component:Withdraw,meta:{title:'menarik'}},
    {path:'/Personalreport',name:'Personalreport',component:Personalreport,meta:{title:'laporan pribadi'}},
    {path:'/WithdrawRecord',name:'WithdrawRecord',component:WithdrawRecord,meta:{title:'Catatan permainan'}},
    {path:'/GameRecord',name:'GameRecord',component:GameRecord,meta:{title:'Pengenalan misi'}},
    {path:'/Account',name:'Account',component:Account,meta:{title:'Pengenalan misi'}},
    {path:'/Guide',name:'Guide',component:()=>import('@/pages/home/guide'),meta:{title:'Guide'}},
    {path:'/VipCard',name:'VipCard',component:()=>import('@/pages/mine/VipCard'),meta:{title:'VipCard'}},
    {path:'/History',name:'history',component:History,meta:{title:'History'}},
    {path:'/Trc20',name:'trc20',component:Trc20,meta:{title:'Trc20'}},
    {path:'/Settrc',name:'settrc',component:Settrc,meta:{title:'settrc'}},
    {path:'/TrcCard',name:'trcCard',component:TrcCard,meta:{title:'trcCard'}},
    {path:'/Torules',name:'torules',component:Torules,meta:{title:'torules'}},
];

//生成路由实例
const router = new VueRouter({
    routes
})
router.beforeEach((to,from,next) => {         //修改标题路由配置加上这个
    const pageTitle = to.matched[0] && to.matched[0].meta ? to.matched[0].meta.title : ''
    document.title = pageTitle ? `${pageTitle} - Meet` : 'Meet'
    next()
})

export default router
